const Config = {
  baseUrl: 'https://localhost:44300',
  apiUrl: 'http://localhost:5000/api/',
  identity: {
    url: 'https://preprod-login.mhelpdesk.com',
    client_secret: 'test123',
    client_id: 'passwordless_ui',
  },
  googleMapKey: 'AIzaSyAsAabAn1M5xkm8SxZqES4XOulFIGjt9f8',
  launchDarklyClientId: '5d8cba91622e3407a785a76c',
  mapQuestAPI: 'https://www.mapquestapi.com/search/v3/prediction',
  mapQuestAPIKey: 's5dBmTfK0OiSbGfEL8wU9IzPfNgaPNAR',
  qbUrl: 'https://dev-qb.mhelpdesk.com:4433/',
  qboUrl: 'https://preprod-quickbooks.mhelpdesk.com/Default.aspx',
  fuseBill: {
    publicKey: '6498cf27-4dc8-4bc6-b21a-ae3c46b8912e',
    transparentRedirectUrl:
      'https://payments.subscriptionplatform.com/api/paymentsv2/',
  },
  authScriptUrl: 'https://jstest.authorize.net/v3/AcceptUI.js',
  wePayServerMode: 'stage',
  wePayUrl: 'https://stage.wepay.com/login',
  pdfUrl: '',
  recurTestInverval: true,
  flagProvider: 'launchDarkly',
  showOldEstimateInvoiceLink: true,
  envName: 'dev',
};

export default Config;



// WEBPACK FOOTER //
// ./src/config/config.Dev.js